<template>
  <VueApexCharts
    type="area"
    :height="chartHeight"
    :options="chartOptions"
    :series="[
      {
        name: symbol,
        data: selectedStockClosePriceChartData,
      },
    ]"
  />
</template>
<script setup>
import { ref, computed, onMounted, reactive, watchEffect } from "vue";

import useData from "src/use/data";
import useMarket from "src/use/market";
import { LocalStorage, useQuasar } from "quasar";
import moment from "moment";
import { useStore } from "vuex";

import VueApexCharts from "vue3-apexcharts";

const props = defineProps({
  symbol: { type: String, required: true },
  chartHeight: { type: Number, default: null },
});

const { marketTime, getNepalTime } = useMarket();
const store = useStore();
const $q = useQuasar();

let stockPerformanceData = reactive({
  close: "",
  point_change: "",
  percentage_change: "",
});
const selectedIndex = ref(null);
const isMarketOn = ref(LocalStorage.getItem("isMarketOn"));

const selectedStockClosePriceData = ref(null);
const selectedStockClosePriceChartData = ref([]);

const { intraHistoryDataSearch, intraStockPerformance, dailyNepse } = useData();

const chartOptions = computed(() => ({
  chart: {
    type: "area",
    height: props.chartHeight,
    zoom: {
      enabled: true,
      type: "x",
      autoScaleYaxis: true,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: "smooth",
    width: 2,
  },
  title: {
    text: `Today's Market Summary of ${props.symbol}`,
    align: "left",
    style: {
      fontSize: "13px",
      color: $q.dark.mode ? "#fff" : "#000",
    },
  },
  xaxis: {
    datetimeUTC: false,
    tickPlacement: "between",
    type: "time",
    tickAmount: 5,
    tickPlacement: "between",
    labels: {
      rotate: 0,
      style: {
        colors: $q.dark.mode ? "#fff" : "#000",
      },
    },
  },
  yaxis: {
    opposite: true,
    decimals: 0,
    labels: {
      formatter: function (val) {
        return parseInt(val);
      },
      style: {
        colors: $q.dark.mode ? "#fff" : "#000",
      },
    },
  },
  legend: {
    horizontalAlign: "left",
  },
  colors: stockPerformanceData.point_change > 0 ? ["#15996d"] : ["#ff3366"],
  tooltip: $q.dark.mode ? { theme: "dark" } : { theme: "light" },
}));

const loadData = (symbol) => {
  intraStockPerformance().then((res) => {
    selectedStockClosePriceData.value = res.data.find(
      (i) => i.symbol == symbol
    );
    if (selectedStockClosePriceData.value) {
      stockPerformanceData.close = selectedStockClosePriceData.value.close;
      stockPerformanceData.point_change =
        selectedStockClosePriceData.value.point_change;
      stockPerformanceData.percentage_change =
        selectedStockClosePriceData.value.percentage_change;
    }
  });

  if (symbol) {
    dailyNepse(symbol).then((res) => {
      selectedStockClosePriceChartData.value = res.data.data
        .filter((item) => {
          var time = getNepalTime(item.date);
          return isMarketOn.value
            ? time.getTime() >= marketTime.start
            : time.getTime() >= getNepalTime(store.state.market.asOf).getTime();
        })
        .map((item) => {
          return {
            x: item.time,
            y: parseFloat(item.close),
          };
        })
        .reverse();
    });
  }

};
watchEffect(() => {
  const newVal = props.symbol;
  loadData(newVal);
});
</script>
